<template>
    <div>
        <Nav></Nav>
        <PageHeader :linkto="'/home'" :linkttitle="'返回'" :title="productName"></PageHeader>
        <b-container>
            <FormSelfBox></FormSelfBox>
            <TipsAlert :tipswords="masterTips.tipswords"
                       :status="masterTips.status"
                       :videostatus="masterTips.videostatus"
                       :videosrc="masterTips.videosrc">

            </TipsAlert>
            <div class="text-center my-4">
                <h5 class="text-center">選擇你的對手人數</h5>
                <div>
                    <b-button pill :variant="member==1?'primary':'outline-primary'" class="mx-2" size="lg"
                              @click="controlMember(1)">1人
                    </b-button>
                    <b-button pill :variant="member==2?'primary':'outline-primary'" class="mx-2" size="lg"
                              @click="controlMember(2)">2人
                    </b-button>
                    <b-button pill :variant="member==3?'primary':'outline-primary'" class="mx-2" size="lg"
                              @click="controlMember(3)">3人
                    </b-button>
                </div>

            </div>

            <FormCompareBox v-if="member>=1" ref="model1" v-on:sendAction="oneData" :familiarFnu="false"
                            :subtitle="'對手1'" class="mb-2"></FormCompareBox>
            <FormCompareBox v-if="member>=2" ref="model2" v-on:sendAction="twoData" :familiarFnu="false"
                            :subtitle="'對手2'" class="mb-2"></FormCompareBox>
            <FormCompareBox v-if="member>=3" ref="model3" v-on:sendAction="threeData" :familiarFnu="false"
                            :subtitle="'對手3'" class="mb-2"></FormCompareBox>
            <b-button pill block variant="primary" size="lg" class="text-white shadow-lg my-3 "
                      style=" background: linear-gradient(180deg, rgba(215,176,128,1) 0%, rgba(164,120,85,1) 100%)"
                      @click="callaction">進行分析
            </b-button>
        </b-container>
        <AnaLoading way="Normal" :show="pageloading"></AnaLoading>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import PageHeader from '@/components/PageHeader.vue'
import FormSelfBox from '@/components/FormSelfBox.vue'
import FormCompareBox from '@/components/FormCompareBox.vue'
import AnaLoading from '@/components/AnaLoading.vue'
import TipsAlert from '@/components/TipsAlert.vue'

export default {
  name: 'Master',
  components: {Nav, PageHeader, FormSelfBox, FormCompareBox, AnaLoading,TipsAlert},
  data () {
    return {
      productName: '高手過招',
      oneformData: {
        name: '',
        type: '',
        sex: ''
      },
      twoformData: {
        name: '',
        type: '',
        sex: ''
      },
      threeformData: {
        name: '',
        type: '',
        sex: ''
      },
      pageloading: false,
      member: 1,
      oneCheck: false,
      twoCheck: false,
      threeCheck: false,
      masterTips:{
        status:true,
        videostatus:false,
        videosrc:'',
        tipswords:'（高手過招）人際相處上，偶爾會玩玩小牌、打打麻將，除了消磨時間，紓解壓力之外，雙贏也是很重要的事。我們運用古人的智慧，用顏色相吸與相剋關係，分析出當下該穿著什麼顏色，來幫自己在牌桌上佔上風。',
      },
    }
  },
  mounted () {

    // let data = [
    //   {
    //     name: '建议',
    //     type: 0,
    //     sex: 1
    //   },
    //   {
    //     name: '勝利',
    //     type: 0,
    //     sex: 1
    //   }
    // ]
    // this.GoMasterFree(data)
  },
  methods: {
    controlMember (num) {
      this.member = num
    },
    callaction () {
      if (this.member >= 1) {
        this.$refs.model1.toggleModal()
      }
      if (this.member >= 2) {
        this.$refs.model2.toggleModal()
      }
      if (this.member >= 3) {
        this.$refs.model3.toggleModal()
      }

    },
    oneData (data) {
      this.oneformData.name = data.name
      this.oneformData.type = data.type
      this.oneformData.sex = data.sex
      this.oneCheck = true
      this.MixData()
    },
    twoData (data) {
      this.twoformData.name = data.name
      this.twoformData.type = data.type
      this.twoformData.sex = data.sex
      this.twoCheck = true
      this.MixData()
    },
    threeData (data) {
      this.threeformData.name = data.name
      this.threeformData.type = data.type
      this.threeformData.sex = data.sex
      this.threeCheck = true
      this.MixData()
    },
    MixData () {
      let manedata = []

      if (this.member == 1 & this.oneCheck) {
        Array.prototype.push.apply(manedata, [this.oneformData])
        this.GoMasterFree(manedata)
      } else if (this.member == 2 & this.oneCheck & this.twoCheck) {
        Array.prototype.push.apply(manedata, [this.oneformData])
        Array.prototype.push.apply(manedata, [this.twoformData])
        this.GoMasterFree(manedata)
      } else if (this.member == 3 & this.threeCheck & this.twoCheck) {
        Array.prototype.push.apply(manedata, [this.oneformData])
        Array.prototype.push.apply(manedata, [this.twoformData])
        Array.prototype.push.apply(manedata, [this.threeformData])
        this.GoMasterFree(manedata)
      }

    },
    GoMasterFree (data) {
      this.pageloading = true
      this.$store.dispatch('actionAnaResult', {
        manedata: data,
        producttype: 'MasterFree'
      }).then((res) => {
        setTimeout(() => {
          this.pageloading = false
          this.$router.push('/MasterResult')
        }, 1000)
      }).catch((res) => {
        this.pageloading = false
      })
    }

  }
}
</script>

<style scoped>

</style>
